<template>
<div>
    <van-row>
      <van-calendar v-model="show" :default-date="vantDate.defaultDate" :min-date="vantDate.minDate" color="#409EFF"
                    @confirm="onConfirm"/> 
      <van-col span="24" class="title-blue">
        <div>
          <span>患者随访报表</span>
          <span style="float: right" @click="show=true">{{searchDate}}
            <van-icon name="play" style="float: right" class="arrow"/>
        </span>
        </div>
      </van-col>
    </van-row>
    <van-row class="btn-row">
      <van-col span="12" class="btn-left"  :class="showdoneData===1?'selected':'UnSelected'" @click="getDoneData()">完成率</van-col>
      <van-col span="12" class="btn-right" :class="showdoneData===1?'UnSelected':'selected'" @click="getOntimedoneData()" >按时完成率</van-col>
    </van-row>
    <div v-if="showdoneData===1">
      <!--全院权限人员权限-->
      <van-row class="round-blue" v-show="showWhole">
        <van-col span="11" style="text-align: left">
          全院随访人数
        </van-col>
        <van-col span="4">
          已随访
        </van-col>
        <van-col span="4">
          需随访
        </van-col>
        <van-col span="5">
          完成率
        </van-col>
      </van-row>
      <van-row class="row-white" v-show="showWhole">
        <van-col span="11" style="text-align: left">
          {{wholeCallTotalNum}}
        </van-col>
        <van-col span="4">
          {{wholeCallDoneNum}}
        </van-col>
        <van-col span="4">
          {{wholeCallUnfinishedNum}}
        </van-col>
        <van-col span="5">
          {{doneRate}}
        </van-col>
      </van-row>
      <van-row class="round-blue">
        <van-col span="11" style="text-align: left">
          随访科室
        </van-col>
        <van-col span="4">
          已随访
        </van-col>
        <van-col span="4">
          需随访
        </van-col>
        <van-col span="5">
          完成率
        </van-col>
      </van-row>
      <div v-for="(item,index) in feedbackCallResultList " :key="index">
        <van-row class="row-white">

          <van-col span="11" style="text-align: left">
            {{item.departmentName}}
          </van-col>
          <van-col span="4">
            {{item.callDoneNum}}
          </van-col>
          <van-col span="4">
            {{item.callUnfinishedNum}}
          </van-col>
          <van-col span="5">
            {{item.doneRate}}
          </van-col>
        </van-row>
      </div>
    </div>


    <div v-if="showdoneData===0">
      <!--全院权限人员权限-->
      <van-row class="round-blue" v-show="showWhole">
        <van-col span="11" style="text-align: left">
          全院随访人数
        </van-col>
        <van-col span="6">
          未按时完成
        </van-col>
        <van-col span="7">
          按时完成率
        </van-col>
      </van-row>
      <van-row class="row-white" v-show="showWhole">
        <van-col span="11" style="text-align: left">
          {{wholeCallTotalNum}}
        </van-col>
        <van-col span="6">
          {{wholeUnOntimeDoneNum}}
        </van-col>
        <van-col span="7">
          {{wholeOntimeDoneRate}}
        </van-col>
      </van-row>

      <van-row class="round-blue">
        <van-col span="11" style="text-align: left">
          随访科室
        </van-col>
        <van-col span="6">
          未按时完成
        </van-col>
        <van-col span="7">
          按时完成率
        </van-col>
      </van-row>
      <div v-for="(item,index) in feedbackCallResultList " :key="index">
        <van-row class="row-white">

          <van-col span="11" style="text-align: left">
            {{item.departmentName}}
          </van-col>
          <van-col span="6">
            {{item.unOntimeDoneNum}}
          </van-col>
          <van-col span="7">
            {{item.ontimeDoneRate}}
          </van-col>
        </van-row>
      </div>
    </div>
    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>
    <van-row class="row-grey245">
      <van-col span="24"></van-col>
    </van-row>
  </div>
  
</template>

<script>
import api from "@/axios/api";
import { Toast } from "vant";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
      immediate: true,
      handler: function (val) {
        if(val) {
            if (!this.depId) {
              this.showWhole = true;
            }
            this.getFeedbackCallInfo();
         }
      }
    }
  },
  data () {
    return {
      info: '',
        //字符串类型日期
        searchDate: this.$route.query.searchDate,
        depId:this.$route.query.depId,
        //Calendar日历控件
        vantDate: {
          //默认时间 van日历控件只支持date类型参数
          defaultDate: new Date(Date.parse(this.$route.query.searchDate.replace(/-/g, "/"))),
          //可选择最小时间
          minDate: new Date(Date.parse('1970-01'.replace(/-/g, "/")))
        },
        //日期控件默认隐藏
        show: false,
        showWhole:false,
        feedbackCallResultList: [],
        wholeCallTotalNum:'',
        wholeCallDoneNum:'',
        wholeCallUnfinishedNum:'',
        wholeUnOntimeDoneNum:'',
        wholeOntimeDoneRate:'' ,
        doneRate:'',
        //显示已完成率数据
        showdoneData:1
    };
  },

  filters: {},
  mounted () {
    //this.getMatch(this.reportDate);
  },
  methods: {
     onConfirm(date) {
        this.show = false;
        this.searchDate = this.formatDateString(date);
        this.getFeedbackCallInfo();
      },

      //获取电话随访科室结果
      getFeedbackCallInfo() {
        alert("请求成功")
        if(!this.depId){
          api.getFeedbackCallInfo(this.searchDate).then(res => {
            this.feedbackCallResultList = res.callResultLists;
            this.wholeCallTotalNum = res.wholeCallTotalNum;
            this.wholeCallDoneNum = res.wholeCallDoneNum;
            this.wholeCallUnfinishedNum = res.wholeCallUnfinishedNum;
            this.wholeUnOntimeDoneNum = res.wholeUnOntimeDoneNum;
            this.wholeOntimeDoneRate = res.wholeOntimeDoneRate;
            this.doneRate = res.doneRate;
          });
        }else{
          api.getDeptFeedbackCallInfo(this.searchDate,this.depId).then(res => {
            this.feedbackCallResultList = res.callResultLists;
          });

        }
      },

      getDoneData(){
        this.showdoneData = 1
      },
      getOntimedoneData(){
        this.showdoneData = 0
      },


      formatDateString(date){
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + '-' + m + '-' + d;
      }
    }
  
};
</script>

<style lang="less" scoped>
.info-list-table {
    border: 1px black solid;
    width: 100%;
  }

  .num1 {
    font-size: 40px;
    /*color:#027DB4;*/
    font-weight: 600;
  }

  .num2 {
    color: #027DB4;
  }

  .title-blue {
    background: #4187ff;
    color: white;
    height: 50px;
    text-align: left;
    /*align-items: center;
    display: flex;*/
  }

  .title-blue > div {
    padding: 13px 20px 10px 20px;
  }

  .round-grey {
    background: #F0F0F0;
    border: 1px #F0F0F0 solid;
    border-radius: 25px;
    margin-bottom: 20px;
    height: 40px;
    padding: 7px;

  }

  .round-blue {
    background: #E9F0FC;
    color: #5189F6;
    padding: 10px;
    margin: 0 10px 0 10px;
    border-radius: 10px;
    text-align: left;
    font-weight: 500;
  }

  .row-grey245 {
    background: #F5F5F5;
    height: 10px;
  }

  .row-white {
    padding: 10px;
    border-bottom: 1px solid #EEEEEE;
    margin: 0 10px 0 10px;
    text-align: left;
  }

  .arrow {
    color: white;
    margin-top: 3px;
    font-size: 10px;
    transform: rotate(90deg);
    -ms-transform: rotate(90deg); /* IE 9 */
    -moz-transform: rotate(90deg); /* Firefox */
    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
    -o-transform: rotate(90deg); /* Opera */
  }

  .btn-row{
    margin-top: 20px;
    height: 50px;
    padding: 0 20px 0 20px;
  }
  .selected{
    background: rgb(81, 137, 247);
    color: white;
  }
  .UnSelected{
    color: rgb(81, 137, 247);
    background: white;
    border:1px solid rgb(81, 137, 247);
  }
  .btn-left{
    height: 100%;
    padding: 14px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    font-weight: 500;
  }
  .btn-right{
    height: 100%;
    padding: 14px;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    font-weight: 500;
  }
</style>





// WEBPACK FOOTER //
// src/hzsf/feedBackReport.vue